import * as React from 'react';
import { History } from 'history';
import { Text } from '.';
import AppService from '../services/app.service';

interface Props {
  history?: History;
  id?: string;
  label?: string;
  color?: any;
  margin?: number;
  thin?: boolean;
  disableBackButton?: boolean;
  children?: React.ReactNode;
}

export const FormHeader: React.FunctionComponent<Props> = (props) => {
  const isMobile = AppService.isMobile();
  const margin = props.margin || (!props.label?.trim()? 0 : props.children? 1 : 1.7);
  
  const onClick = () => {
    if (!props.disableBackButton) props.history?.goBack();
  }
  
  return (
    <Text label={props.label} color= {props.color || 'text.primary'} size={!isMobile && props.thin? 'medium' : 'large'} lineHeight={1.2} bold={!props.thin} childAlign='space-between' icon={props.disableBackButton? '' : 'west'} iconSize='large' displayBlock onClick={onClick} marginTop={margin} marginBottom={margin}>
      {props.children}
    </Text>

  )
}
